import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useBridgeClubAuth } from '../contexts/BridgeClubAuthContext';

interface Props {
  children: React.ReactNode;
}

const ONBOARDING_PATH = '/bridge-club/onboarding';

const BridgeClubProtectedRoute: React.FC<Props> = ({ children }) => {
  const { isAuthenticated, isLoading, member } = useBridgeClubAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '3px solid #f3f4f6',
          borderTopColor: '#B91C1C',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite'
        }} />
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/bridge-club/login" replace />;
  }

  // The guided setup gate. A member who has not finished the universal onboarding
  // (animals + bins → member.onboarding_complete) is required to complete it before any
  // other Bridge Club page. Keyed on the stored flag, not a live derivation, so a member
  // who later deletes an animal is not re-trapped. The onboarding route itself is exempt
  // so there is no redirect loop; the flow navigates out on its own when finished.
  if (member && !member.onboarding_complete && location.pathname !== ONBOARDING_PATH) {
    return <Navigate to={ONBOARDING_PATH} replace />;
  }

  return <>{children}</>;
};

export default BridgeClubProtectedRoute;
